import $ from 'jquery';

// eslint-disable-next-line no-undef
const obj = agObject;

$('.ag-contact-form').on('submit', (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = $(e.target);

    $.ajax({
        type: 'POST',
        url: obj.ajaxUrl,
        data: form.serialize() + '&action=arc_gestion_do_contact_form',
        dataType: 'json',
        beforeSend() {
            form.addClass('blocked-div');
        },
        success(response) {
            alert(response.data.message);

            if (response.success) {
                form.trigger('reset');
            }
        },
        complete() {
            form.removeClass('blocked-div');
        },
    });
});
